import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, ACCOUNTS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allAccount',
  url: `${ACCOUNTS_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
